export default __webpack_public_path__ + "static/media/Snuff.e4b28f18.png";